import React from 'react';
import { useLanguage } from '../lib/LanguageContext';
const smpImages = [{
  src: 'https://cdn.magicpatterns.com/uploads/wq6LxWgx34ZBUu8FHXLvjD/IMG_8575.jpg',
  alt: 'SMP before and after — thinning crown restored to full density'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/2mgFoSr4or6NHNDrWytZtV/D8A3853D-F662-460C-B7E9-6EBB60E7518D.jpg',
  alt: 'SMP before and after — bald head with hairline mapping to finished result'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/6He2C6fbUdo2QamEiSe1Rc/IMG_8276.jpg',
  alt: 'SMP before and after — crown density restoration from multiple angles'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/pH3vvWr2HWYcTMTJ94xBWr/IMG_8428.jpg',
  alt: 'SMP before and after — hairline creation and density'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/98emtno8Wxta89cEJik8fP/IMG_9471.jpg',
  alt: 'SMP before and after — full transformation with natural hairline'
}];
export function SMPGallerySection() {
  const {
    t
  } = useLanguage();
  const doubled = [...smpImages, ...smpImages];
  return <div className="my-12" data-id="element-166">
      <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl text-white font-bold mb-3 text-center" data-id="element-167">
        {t.smpGallery.heading}
      </h2>
      <a href="https://www.instagram.com/hairinkrestoration" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 mb-6 text-white hover:opacity-80 transition-opacity" data-id="element-168">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-169">
          <defs data-id="element-170">
            <radialGradient id="ig-grad-smp" cx="30%" cy="107%" r="150%" data-id="element-171">
              <stop offset="0%" stopColor="#fdf497" data-id="element-172" />
              <stop offset="5%" stopColor="#fdf497" data-id="element-173" />
              <stop offset="45%" stopColor="#fd5949" data-id="element-174" />
              <stop offset="60%" stopColor="#d6249f" data-id="element-175" />
              <stop offset="90%" stopColor="#285AEB" data-id="element-176" />
            </radialGradient>
          </defs>
          <rect x="2" y="2" width="20" height="20" rx="5" stroke="url(#ig-grad-smp)" strokeWidth="2" data-id="element-177" />
          <circle cx="12" cy="12" r="5" stroke="url(#ig-grad-smp)" strokeWidth="2" data-id="element-178" />
          <circle cx="17.5" cy="6.5" r="1.5" fill="url(#ig-grad-smp)" data-id="element-179" />
        </svg>
        <span className="font-['Source_Sans_3'] text-sm uppercase tracking-[0.2em] text-white" data-id="element-180">
          @hairinkrestoration
        </span>
      </a>
      <p className="text-[#f5f0e8]/80 text-lg md:text-xl leading-relaxed text-center max-w-2xl mx-auto mb-10" data-id="element-181">
        {t.smpGallery.description}
      </p>
      <div className="overflow-hidden" data-id="element-182">
        <div className="carousel-track-right flex gap-3 w-max" data-id="element-183">
          {doubled.map((image, index) => <div key={index} className="flex-shrink-0 w-[400px] md:w-[500px] overflow-hidden border border-[#c9a84c]/30" data-id="element-184">
              <img src={image.src} alt={image.alt} className="w-full h-auto" data-id="element-185" />
            </div>)}
        </div>
      </div>
    </div>;
}